import cookie from 'js-cookie'
import { useConfig } from '@/helpers/config';

const getIdFromCookie = function(name) {
    const id = cookie.get(name)
    if ( id ) {
        return parseInt(id)
    }    
    return null
}

export function useLogin() {

    const isLogged = ( useToken() !== null ),
        clientId = useSelectedClient(),
        siteId = useSelectedSite()

    return {
        isLogged,
        clientId,
        siteId
    }
}

export function useSelectedClient() {
    return useConfig().CLIENT_ID || getIdFromCookie('adelya_selected_client_id')
}

export function useSelectedSite() {
    return useConfig().SITE_ID || getIdFromCookie('adelya_selected_site_id')
}

export function useToken() {
    return cookie.get('adelya_token') || null
}

export function isNotImpersonated() {
    return !cookie.get('adelya_impersonated_from')
}